import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editProduct } from "../api/editProduct";
import type { ProductData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useEditProduct = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: ProductData) => editProduct(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: withPrefix(['products']) });
        },
    });
};
